<template>
  <div class="h-dvh flex p-2 sm:p-3">
    <div class="flex-1 flex rounded-lg ring ring-default bg-default/75 shadow min-w-0 overflow-hidden">
      <slot />
    </div>
  </div>
</template>
